<template lang="">
  <div class="header shadow-5 bg-blue-900">
    <img src="@/assets/logo.png" @click="home()" class="logo m-2" />
    <!--<h3 class="title p-1 m-4 align-items-center text-white">{{ $t("app_title") }}</h3>-->
    <h3 class="title p-1 m-4 align-items-center text-white">{{ this.app_title}}</h3>
    <div class="header-right">
      <div class="p-1 m-2 flex align-items-center">
        <LanguajeSelector></LanguajeSelector>
        <img src="@/assets/logo-AEI-cluster.jpg" class="imgHeader m-1" />
        <img src="@/assets/MINCOTUR-DGIPYME.png" class="imgHeader" />
        <ButtonPrime v-if="logged == true" icon="pi pi-sign-out" class="bg-primary-reverse btn" @click="loggout"/>
      </div>
    </div>
  </div>
</template>

<script>
import LanguajeSelector from "@/components/LanguajeSelector.vue";
import router from "@/router/index.js";
import UserService from "@/services/UserService.ts";

export default {
  name: "HeaderComponent",
  props: {
    app_title : String
  },
  components: {
    LanguajeSelector,
  },
  computed: {
    logged() {
      return this.userService.loggedIn;
    }
  },
  created() {
    this.userService = UserService.getInstance();
  },
  methods: {
    home(){
      if (window.location.href != "https://ecobuq.netlify.app/" && this.logged == true) {

        if(this.app_title === "ECOBUQ"){
          router.push({ name: "home" });
        }else if(this.app_title === "NEOBUQ"){
          router.push({ name: "neobuqHome" });
        }

        } else {
          alert("Ya estas en el Home.");
        }
    },
    loggout() {
      this.userService.loggout();
    }
  }
};
</script>
<style scoped>
/* Style the header with a grey background and some padding */
.header {
  overflow: hidden;
  padding-bottom: 0%;
  /*padding-top: 1%;*/
}

/* Style the header links */
.header a {
  float: left;
  color: black;
  text-align: center;
  padding: 12px;
  text-decoration: none;
  font-size: 18px;
  line-height: 25px;
  border-radius: 4px;
}
.title {
  float: left;
  font-size: 30px;
}
.imgHeader {
  height: 70px;
}
/* Style the logo link (notice that we set the same value of line-height and font-size to prevent the header to increase when the font gets bigger */
.header img.logo {
  font-size: 25px;
  float: left;
  margin-left: 2% !important;
  font-weight: bold;
  width: 4%;
  height: 4%;
}

/* Change the background color on mouse-over */
.header a:hover {
  background-color: #ddd;
  color: black;
}

/* Style the active/current link*/
.header a.active {
  background-color: dodgerblue;
  color: white;
}

/* Float the link section to the right */
.header-right {
  float: right;
  padding-right: 5%;
}

/* Add media queries for responsiveness - when the screen is 500px wide or less, stack the links on top of each other */
@media screen and (max-width: 500px) {
  .header a {
    float: none;
    display: block;
    text-align: left;
  }
  .header-right {
    float: none;
  }
}

.btn{
  margin: 5px !important;
}
</style>
